// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-list-item[data-v-34499fc0]{border-bottom:1px solid #eff2f7!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
